module.exports = __webpack_public_path__ + "static/media/0_2019_09_29.03be8ebd.jpg";